
<template>
  <section id="howtobecome" class="how-to-become-section">
    <div class="container">
      <!-- Header com efeito neon -->
      <div class="section-header">
        <h2 class="neon-title">
          <span class="kanji">道</span>
          Como se Tornar um VTuber
          <span class="subtitle">〜 Virtual Debut Guide 〜</span>
        </h2>
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
      </div>

      <!-- Steps com layout em grid anime-style -->
      <div class="steps-grid">
        <div class="step-card level-1" data-step="1">
          <div class="card-header">
            <div class="step-number">LV.1</div>
            <div class="step-icon anime-icon">
              <i class="fas fa-desktop"></i>
              <div class="icon-glow"></div>
            </div>
            <div class="difficulty">★☆☆☆☆</div>
          </div>
          <h3>Hardware Setup</h3>
          <div class="step-content">
            <p><strong>基本装備 (Kihon Sōbi):</strong></p>
            <ul>
              <li>CPU: Intel i5/AMD Ryzen 5+ (streaming用)</li>
              <li>RAM: 16GB+ (Live2D models)</li>
              <li>GPU: GTX 1060/RX 580+ (3D tracking)</li>
              <li>Audio: Condenser mic (Blue Yeti, Audio-Technica)</li>
              <li>Webcam: 1080p 60fps (face tracking)</li>
            </ul>
          </div>
          <div class="card-footer">
            <span class="cost-estimate">R$ 1.800 - R$ 5.400</span>
          </div>
        </div>

        <div class="step-card level-2" data-step="2">
          <div class="card-header">
            <div class="step-number">LV.2</div>
            <div class="step-icon anime-icon">
              <i class="fas fa-paint-brush"></i>
              <div class="icon-glow"></div>
            </div>
            <div class="difficulty">★★★☆☆</div>
          </div>
          <h3>Avatar Creation</h3>
          <div class="step-content">
            <p><strong>キャラデザ (Character Design):</strong></p>
            <ul>
              <li>Design conceitual + referências</li>
              <li>Comissão de artista (mama/papa)</li>
              <li>Live2D rigging profissional</li>
              <li>Expressões e animações</li>
              <li>Assets extras (outfits, props)</li>
            </ul>
            <div class="pro-tip">
              <i class="fas fa-lightbulb"></i>
              <span>ProTip: Booth.pm tem modelos pré-feitos!</span>
            </div>
          </div>
          <div class="card-footer">
            <span class="cost-estimate">R$ 1.080 - R$ 18.000</span>
          </div>
        </div>

        <div class="step-card level-3" data-step="3">
          <div class="card-header">
            <div class="step-number">LV.3</div>
            <div class="step-icon anime-icon">
              <i class="fas fa-cogs"></i>
              <div class="icon-glow"></div>
            </div>
            <div class="difficulty">★★★★☆</div>
          </div>
          <h3>Software Mastery</h3>
          <div class="step-content">
            <p><strong>技術スタック (Tech Stack):</strong></p>
            <ul>
              <li><strong>VTube Studio:</strong> Live2D tracking</li>
              <li><strong>OBS Studio:</strong> Streaming setup</li>
              <li><strong>VoiceMeeter:</strong> Audio routing</li>
              <li><strong>Streamlabs:</strong> Alerts & widgets</li>
              <li><strong>Discord:</strong> Community management</li>
            </ul>
            <div class="tech-stack">
              <span class="tech-tag">Live2D</span>
              <span class="tech-tag">Face Tracking</span>
              <span class="tech-tag">Motion Capture</span>
            </div>
          </div>
          <div class="card-footer">
            <span class="cost-estimate">Grátis - R$ 720</span>
          </div>
        </div>

        <div class="step-card level-4" data-step="4">
          <div class="card-header">
            <div class="step-number">LV.4</div>
            <div class="step-icon anime-icon">
              <i class="fas fa-theater-masks"></i>
              <div class="icon-glow"></div>
            </div>
            <div class="difficulty">★★★★★</div>
          </div>
          <h3>Persona Development</h3>
          <div class="step-content">
            <p><strong>キャラ設定 (Character Setting):</strong></p>
            <ul>
              <li>Backstory & lore detalhado</li>
              <li>Personalidade única</li>
              <li>Catchphrases e maneirismos</li>
              <li>Conteúdo specialization</li>
              <li>Community guidelines</li>
            </ul>
            <div class="persona-types">
              <span class="persona-tag seiso">清楚 Seiso</span>
              <span class="persona-tag chaotic">混沌 Chaos</span>
              <span class="persona-tag gaming">ゲーマー Gamer</span>
            </div>
          </div>
          <div class="card-footer">
            <span class="cost-estimate">Priceless ∞</span>
          </div>
        </div>

        <div class="step-card level-5" data-step="5">
          <div class="card-header">
            <div class="step-number">LV.5</div>
            <div class="step-icon anime-icon">
              <i class="fas fa-broadcast-tower"></i>
              <div class="icon-glow"></div>
            </div>
            <div class="difficulty">★★★★★</div>
          </div>
          <h3>Debut & Growth</h3>
          <div class="step-content">
            <p><strong>配信開始 (Stream Start):</strong></p>
            <ul>
              <li>Debut stream planning</li>
              <li>Social media presence</li>
              <li>Consistent schedule</li>
              <li>Community building</li>
              <li>Collaboration networking</li>
            </ul>
            <div class="metrics">
              <div class="metric">
                <span class="number">1M+</span>
                <span class="label">Views Goal</span>
              </div>
              <div class="metric">
                <span class="number">10K+</span>
                <span class="label">Subscribers</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="cost-estimate">Time Investment ∞</span>
          </div>
        </div>
      </div>

      <!-- Final message com estilo anime -->
      <div class="final-message">
        <div class="message-box">
          <div class="character-icon">
            <i class="fas fa-heart"></i>
          </div>
          <p class="message-text">
            <strong>頑張って！(Ganbatte!)</strong><br>
            O mais importante é se divertir e ser autêntico! A jornada de um VTuber é cheia de desafios, 
            mas também de momentos incríveis com sua audiência. Lembre-se: cada grande VTuber começou do zero!
          </p>
          <div class="support-links">
            <span class="link-item">r/VirtualYoutubers</span>
            <span class="link-item">VTuber技術部</span>
            <span class="link-item">Booth.pm</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowToBecomeSection',
  mounted() {
    // Animação de entrada dos cards
    this.animateCards();
    // Barra de progresso animada
    this.animateProgressBar();
  },
  methods: {
    animateCards() {
      const cards = document.querySelectorAll('.step-card');
      cards.forEach((card, index) => {
        setTimeout(() => {
          card.classList.add('animate-in');
        }, index * 200);
      });
    },
    animateProgressBar() {
      const progressBar = document.querySelector('.progress-fill');
      setTimeout(() => {
        progressBar.style.width = '100%';
      }, 1000);
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;900&family=Noto+Sans+JP:wght@400;500;700&display=swap');

.how-to-become-section {
  padding: 100px 20px;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);
  position: relative;
  overflow: hidden;
}

.how-to-become-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 64, 129, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

.neon-title {
  font-family: 'Orbitron', 'Noto Sans JP', sans-serif;
  font-size: 3.5rem;
  font-weight: 900;
  color: #fff;
  text-shadow: 
    0 0 10px rgba(255, 64, 129, 0.5),
    0 0 20px rgba(255, 64, 129, 0.3),
    0 0 30px rgba(255, 64, 129, 0.2);
  margin-bottom: 20px;
  position: relative;
}

.kanji {
  font-size: 4rem;
  color: #ff4081;
  margin-right: 20px;
  text-shadow: 
    0 0 15px rgba(255, 64, 129, 0.8),
    0 0 30px rgba(255, 64, 129, 0.5);
}

.subtitle {
  display: block;
  font-size: 1.2rem;
  font-weight: 400;
  color: #b0b0b0;
  margin-top: 10px;
  font-family: 'Noto Sans JP', sans-serif;
}

.progress-bar {
  width: 300px;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  margin: 30px auto;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #ff4081, #7b1fa2, #3f51b5);
  width: 0;
  transition: width 3s ease-out;
  border-radius: 2px;
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.step-card {
  background: linear-gradient(145deg, #1e1e2e, #2a2a3a);
  border: 2px solid #3a3a4a;
  border-radius: 20px;
  padding: 30px;
  position: relative;
  transform: translateY(50px);
  opacity: 0;
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: hidden;
}

.step-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #ff4081, #7b1fa2);
}

.step-card.animate-in {
  transform: translateY(0);
  opacity: 1;
}

.step-card:hover {
  transform: translateY(-10px) scale(1.02);
  border-color: #ff4081;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(255, 64, 129, 0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.step-number {
  font-family: 'Orbitron', sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #ff4081;
  background: rgba(255, 64, 129, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 64, 129, 0.3);
}

.anime-icon {
  position: relative;
  font-size: 2.5rem;
  color: #ff4081;
}

.icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: radial-gradient(circle, rgba(255, 64, 129, 0.2) 0%, transparent 70%);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.7; }
  50% { transform: translate(-50%, -50%) scale(1.2); opacity: 1; }
}

.difficulty {
  font-size: 1.2rem;
  color: #ffd700;
}

.step-card h3 {
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
}

.step-content {
  margin-bottom: 20px;
}

.step-content p {
  color: #e0e0e0;
  margin-bottom: 15px;
  font-weight: 500;
}

.step-content ul {
  list-style: none;
  padding: 0;
}

.step-content li {
  color: #b0b0b0;
  padding: 8px 0;
  padding-left: 20px;
  position: relative;
  font-size: 0.95rem;
  line-height: 1.6;
}

.step-content li::before {
  content: '▶';
  position: absolute;
  left: 0;
  color: #ff4081;
  font-size: 0.8rem;
}

.pro-tip {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(255, 152, 0, 0.1));
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 10px;
  padding: 12px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.pro-tip i {
  color: #ffc107;
}

.pro-tip span {
  color: #fff;
  font-size: 0.9rem;
}

.tech-stack, .persona-types {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
}

.tech-tag, .persona-tag {
  background: rgba(123, 31, 162, 0.2);
  border: 1px solid rgba(123, 31, 162, 0.4);
  color: #e1bee7;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 500;
}

.persona-tag.seiso {
  background: rgba(76, 175, 80, 0.2);
  border-color: rgba(76, 175, 80, 0.4);
  color: #c8e6c9;
}

.persona-tag.chaotic {
  background: rgba(244, 67, 54, 0.2);
  border-color: rgba(244, 67, 54, 0.4);
  color: #ffcdd2;
}

.persona-tag.gaming {
  background: rgba(33, 150, 243, 0.2);
  border-color: rgba(33, 150, 243, 0.4);
  color: #bbdefb;
}

.metrics {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.metric {
  text-align: center;
}

.metric .number {
  display: block;
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #ff4081;
}

.metric .label {
  font-size: 0.8rem;
  color: #b0b0b0;
}

.card-footer {
  text-align: center;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.cost-estimate {
  font-family: 'Orbitron', sans-serif;
  font-weight: 700;
  color: #4caf50;
  font-size: 1.1rem;
}

.final-message {
  text-align: center;
}

.message-box {
  background: linear-gradient(145deg, #2a2a3a, #1e1e2e);
  border: 2px solid #ff4081;
  border-radius: 20px;
  padding: 40px;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
}

.character-icon {
  font-size: 3rem;
  color: #ff4081;
  margin-bottom: 20px;
  animation: heartbeat 1.5s infinite;
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.message-text {
  color: #e0e0e0;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 25px;
}

.message-text strong {
  color: #ff4081;
  font-family: 'Noto Sans JP', sans-serif;
}

.support-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.link-item {
  background: rgba(255, 64, 129, 0.1);
  border: 1px solid rgba(255, 64, 129, 0.3);
  color: #ff4081;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.link-item:hover {
  background: rgba(255, 64, 129, 0.2);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .how-to-become-section {
    padding: 60px 15px;
  }

  .neon-title {
    font-size: 2.5rem;
  }

  .kanji {
    font-size: 3rem;
    margin-right: 10px;
  }

  .steps-grid {
    gap: 20px;
  }

  .step-card {
    padding: 20px;
  }

  .card-header {
    flex-direction: column;
    gap: 15px;
  }

  .metrics {
    flex-direction: column;
    gap: 10px;
  }

  .support-links {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .steps-grid {
    grid-template-columns: 1fr;
  }

  .neon-title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .message-box {
    padding: 25px;
  }
}
</style>
